import { Auth } from '@aws-amplify/auth'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { t } from 'i18n-js'
import { toast } from 'react-toastify'
import useAuthSession from './useAuthSession'
import useUser from './useUser'

async function logout(): Promise<void> {
  await Auth.signOut()
}

const useLogout = () => {
  const { loadAuthSession } = useAuthSession()
  const { refetch: loadUser } = useUser()
  const queryClient = useQueryClient()

  const loginMutation = useMutation({
    mutationKey: ['logout'],
    mutationFn: () => {
      return logout()
    },
    onSuccess: () => {
      loadAuthSession()
      loadUser()
      localStorage.clear()
      queryClient.clear()
      queryClient.removeQueries({ queryKey: ['user', 'authSession'] })
    },
    onError: error => {
      loadAuthSession()
      loadUser()
      localStorage.clear()
      queryClient.clear()
      queryClient.removeQueries({ queryKey: ['user', 'authSession'] })

      const translatedError = t(error.name)
      toast.error(translatedError)
    }
  })

  return { ...loginMutation }
}

export default useLogout
